export default __webpack_public_path__ + "static/media/wwsport.63436972.jpg";